import 'es6-promise/auto'
import Vue from 'vue'
import App from './App.vue'
import {router} from './router'
import store from './store'

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

import VueMeta from 'vue-meta'
Vue.use(VueMeta)

const VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo)

Vue.config.productionTip = false

Vue.config.errorHandler = (err, vm, info) => {
  err;vm;info;
  // console.log('err', err)
  // console.log('vm', vm)
  // console.log('info', info)
  router.push({ name: 'rep320' })
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
